import { Grid, Typography, Box, Input } from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';


export const Images = () => {
    return (
        <>
            <Grid item xs={8} sx={{ display: "flex", flexDirection: "column" }}>
                <Typography fontSize="12px" m="1rem 0rem 0.5rem" sx={{ color: '#747C84' }}> Images <Box component="span" fontSize="12px" color="red">*</Box></Typography>
                <Box sx={{ height: "100%", display: "flex" }}>
                    <Box sx={{ height: "100%", width: "30%", display: "flex", flexDirection: "column" }}>
                        <Box sx={{ border: "1px dashed grey", width: "100%", flex: 1, borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", position: "relative", transition: "0.25s", ":hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                                borderColor: "black",
                                }, }}>
                            <AddPhotoAlternateIcon fontSize="large"/>
                            <Input type="file" accept="image/*" sx={{ opacity: 0, cursor: "pointer", position: "absolute", width: "100%", height: "100%", zIndex: 1, "& .MuiInputBase-input": { height: "100%" },}}/>
                        </Box>
                        <Typography fontSize={11} textAlign="center" mt="0.25rem" sx={{ color: '#747C84' }}>
                            Main Image
                        </Typography>
                    </Box>
                    <Box sx={{ height: "162px", flexGrow: 1, display: "grid", gridTemplateColumns: "repeat(4, 1fr)", overflowX: "auto" }}>
                        {["Primary", "Secondary", "Add more", "Add more", "Add more", "Add more", "Add more", "Add more", "Add more"].map((v) => (
                            <Box sx={{ height: "81px", width: "100%", display: "flex", flexDirection: "column", pl: "0.5rem" }}>
                                <Box sx={{ border: "1px dashed grey", width: "100%", flex: 1, borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", position: "relative", transition: "0.25s", ":hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                                borderColor: "black",
                                }, }}>
                                    <AddPhotoAlternateIcon fontSize="small"/>
                                    <Input type="file" accept="image/*" sx={{ opacity: 0, cursor: "pointer", position: "absolute", width: "100%", height: "100%", zIndex: 1, "& .MuiInputBase-input": { height: "100%" },}}/>
                                </Box>
                                <Typography fontSize={11} textAlign="center" mb="0.25rem" sx={{ color: '#747C84' }}>
                                    {v}
                                </Typography>
                            </Box>
                        ))
                        }
                    </Box>
                </Box>
            </Grid>
        </>
    )
}
